import React, { useEffect, useState } from 'react';
import { Container, Jumbotron, TabContainer } from 'react-bootstrap';
import Team from '../Team/Team';

const Home = () => {
    const [teams, setTeams] = useState([]);
    useEffect(() => {
        fetch(`https://www.thesportsdb.com/api/v1/json/1/lookup_all_teams.php?id=4328`)
            .then(res => res.json())
            .then(data => setTeams(data.teams));
 }, [])
    
    return (
        <div>
            <h2 className="col-sm-12 col-md-12 " style={{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%,-50%)',color:'white',textAlign:'center'}}>English Premier League Teams</h2>
            {
            teams.map(team => <Team team={team} ></Team>)
            }

            
            
        </div>
    );
};

export default Home;